"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentCapture = void 0;
var TextInfo_1 = require("./TextInfo");
var getTelemetryDvsClient_1 = require("./getTelemetryDvsClient");
var locale_1 = require("../locale");
var telemetryTreewalker_1 = require("./telemetryTreewalker");
var telemetryConstants_1 = require("./telemetryConstants");
//Custom callBack function with map involved
function customCallBack(mutationList, categoryTextMap) {
    mutationList.forEach(function (mutation) {
        if (mutation.addedNodes.length) {
            var node = Array.from(mutation.addedNodes)[0];
            (0, telemetryTreewalker_1.telemetryTreeWalker)(node, categoryTextMap);
        }
    });
}
//observerOptions for mutation API
var observerOptions = {
    childList: true,
    subtree: true,
};
//Performs the main function of the contentCapture
//Sampling based on the percentage
//Using mutation Api to capture the changed DOM nodes
//Store them and load them into the telemetry message
//Using telemetry.js to send the events for every 5 seconds
function contentCapture(currentLocale, appName, telemetryClient) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, textCategoryMap_1, observer, emptyCount_1, telemetrySend_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = window !== undefined;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, getTelemetryDvsClient_1.allowContentCapture)(telemetryClient, appName)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    //captureJudgeDV will be used to do the sampling on production
                    //capture content only when locale is set to be no en-US
                    if (_a && currentLocale !== locale_1.Locale.EN_US) {
                        textCategoryMap_1 = new TextInfo_1.CategoryMapTextInfo();
                        //capture the content for static pages content
                        window.onload = function () {
                            (0, telemetryTreewalker_1.telemetryTreeWalker)(document.body, textCategoryMap_1);
                        };
                        observer = new MutationObserver(function (mutationList) {
                            customCallBack(mutationList, textCategoryMap_1);
                        });
                        observer.observe(document.body, observerOptions);
                        emptyCount_1 = 0;
                        telemetrySend_1 = setInterval(function () {
                            return __awaiter(this, void 0, void 0, function () {
                                var message;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!!textCategoryMap_1.isEmpty()) return [3 /*break*/, 3];
                                            message = textCategoryMap_1.loadTelemetryMessage();
                                            if (!telemetryClient) return [3 /*break*/, 2];
                                            return [4 /*yield*/, telemetryClient.event(telemetryConstants_1.TELEMETRY_TOPIC_NAME, message)];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            //clear the textCategoryMap
                                            textCategoryMap_1.resetMap();
                                            emptyCount_1 = 0;
                                            return [3 /*break*/, 4];
                                        case 3:
                                            emptyCount_1 += 1;
                                            _a.label = 4;
                                        case 4:
                                            //After 300s inactive then clear the interval
                                            if (emptyCount_1 === 60) {
                                                clearInterval(telemetrySend_1);
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }, 5000);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.contentCapture = contentCapture;
